import * as Types from 'src/actions/project/comments/get/Types';
import { Action } from 'redux';
import { ThunkAction } from 'redux-thunk';
import { ActionCreator, Dispatch } from 'react-redux';
import ApiClient from 'src/services/api-client/ApiClient';
import { AxiosResponse } from 'axios';
import { RootState } from 'src/reducers/RootReducer';
import ProjectComment from 'src/entities/ProjectComment';
import IndexResponse from 'src/value-objects/IndexResponse';
import ValidatorService from 'src/services/validation/Validation.service';

export interface GetProjectCommentsAttempt extends Action {
  type: Types.GET_PROJECT_COMMENTS_ATTEMPT;
}

export interface GetProjectCommentsSuccess extends Action {
  type: Types.GET_PROJECT_COMMENTS_SUCCESS;
  payload: ProjectComment[];
}

export interface GetProjectCommentsFailure extends Action {
  type: Types.GET_PROJECT_COMMENTS_FAILURE;
  payload: {};
}

export type GetProjectCommentsAction =
  GetProjectCommentsAttempt
  | GetProjectCommentsSuccess
  | GetProjectCommentsFailure;

export interface GetProjectCommentsThunk extends ThunkAction<Promise<GetProjectCommentsAction>, RootState, string> {
}

export const getProjectCommentsAttempt: ActionCreator<GetProjectCommentsAttempt> = () => (
  {
    type: Types.GET_PROJECT_COMMENTS_ATTEMPT
  }
);

export const getProjectCommentsSuccess: ActionCreator<GetProjectCommentsSuccess> = (
  comments: ProjectComment[]) => (
  {
    type: Types.GET_PROJECT_COMMENTS_SUCCESS,
    payload: comments
  }
);

export const getProjectCommentsFailure: ActionCreator<GetProjectCommentsFailure> = (error: {}) => (
  {
    type: Types.GET_PROJECT_COMMENTS_FAILURE,
    payload: error
  }
);

export const getProjectComments: ActionCreator<GetProjectCommentsThunk> =
  (id: string): GetProjectCommentsThunk => {
    return (dispatch: Dispatch<RootState>): Promise<GetProjectCommentsAction> => {
      dispatch(getProjectCommentsAttempt());

      return ApiClient.projectComment.index({projectId: id})
        .then((response: AxiosResponse<IndexResponse<ProjectComment>>): GetProjectCommentsSuccess => {
          return dispatch(getProjectCommentsSuccess(response.data.content));
        }).catch((e: { response: { data: { error: {} } } }): GetProjectCommentsFailure => {
          const errorMessages = ValidatorService
          .translateValidations(e && e.response && e.response.data && e.response.data.error);

          return dispatch(getProjectCommentsFailure(errorMessages));
        });
    };
  };



// WEBPACK FOOTER //
// ./src/actions/project/comments/get/GetProjectComments.actions.tsx